import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

export async function getTreinamentos() {
  try {
    const { data } = await authHttp().get(routes.urlTreinamentos)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTreinamentoById(id) {
  try {
    const { data } = await authHttp().get(routes.urlTreinamentoById(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveTreinamento(treinamento) {
  try {
    const { data } = treinamento.id
      ? await authHttp().put(routes.urlTreinamentoPut(treinamento.id), treinamento)
      : await authHttp().post(routes.urlTreinamentoPost, treinamento)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteTreinamento(id) {
  try {
    const { data } = await authHttp().delete(routes.urlTreinamentoDelete(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getMateriais(treinamentoId) {
  try {
    const { data } = await authHttp().get(routes.urlTreinamentoMateriais(treinamentoId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveMaterial(treinamentoId, material) {
  try {
    const { data } = await authHttp().post(routes.urlTreinamentoMaterialPost(treinamentoId), material)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteMaterial(id) {
  try {
    const { data } = await authHttp().delete(routes.urlTreinamentoMaterialDelete(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function uploadMaterialToS3(treinamentoId, file) {
  try {
    const formData = new FormData()
    formData.append('material', file)
    const { data } = await authHttp().post(routes.urlTreinamentoMaterialUpload(treinamentoId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteMaterialFromS3(filename) {
  try {
    const { data } = await authHttp().delete(routes.urlTreinamentoMaterialS3Delete(filename))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getActiveTps() {
  try {
    const { data } = await authHttp().get(routes.urlTreinamentosActiveTps)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getActiveCompanies() {
  try {
    const { data } = await authHttp().get(routes.urlTreinamentosActiveCompanies)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
